import { useTranslation } from 'react-i18next';
import { type FiservPaymentModuleSpecsFragment } from '../../../../../api/fragments/FiservPaymentModuleSpecs';
import {
    CreateFiservPaymentModuleDocument,
    type CreateFiservPaymentModuleMutation,
    type CreateFiservPaymentModuleMutationVariables,
} from '../../../../../api/mutations/createFiservPaymentModule';
import { type FiservPaymentModuleSettings } from '../../../../../api/types';
import InputField from '../../../../../components/fields/InputField';
import validators from '../../../../../utilities/validators';
import FiservPaymentModulePage, { type FiservPaymentModulePageProps } from '../../FiservPaymentModulePage';
import { type ModuleImplementation } from './types';

const implementation: ModuleImplementation<FiservPaymentModuleSpecsFragment, FiservPaymentModuleSettings> = {
    PageComponent: ({ module }: FiservPaymentModulePageProps) => <FiservPaymentModulePage module={module} />,
    getTitle: t => t('moduleDetails:implementations.FiservPaymentModule.className'),
    getValidator: () => validators.requiredNonEmptyString('displayName'),
    FormComponent: () => {
        const { t } = useTranslation(['moduleDetails']);

        return (
            <InputField
                {...t('moduleDetails:fields.displayName', { returnObjects: true })}
                name="displayName"
                required
            />
        );
    },
    create: async (apolloClient, companyId, values) =>
        apolloClient
            .mutate<CreateFiservPaymentModuleMutation, CreateFiservPaymentModuleMutationVariables>({
                mutation: CreateFiservPaymentModuleDocument,
                variables: {
                    companyId,
                    settings: values,
                },
            })
            .then(({ data }) => data.module),
};

export default implementation;
